import common from "./common";

const blog = {
  init: function () {
    common.bLazy.load($(".news__image"));
    blog.events();
  },

  events: function (wookmark) {
    $("body").on("click", ".category-filter__title", function () {
      let select = $(this).parent();
      select.toggleClass("open");
    });
    $(document).mouseup(function (e) {
      var container = $(".category-filter");

      if (!container.is(e.target) && container.has(e.target).length === 0) {
        container.removeClass("open");
      }
    });
  },
};
export default blog;
